import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import clsx from 'clsx';
import IconButton from 'component/icon/iconButton';
import Icon from 'component/icon';

const TableTabs = (props) => {
    const {
        className,
        style,
        items,
        activeKey: propActiveKey,
        onChange,
        onClose,
        tabBar,
        tableBar,
        tableBarHeight = 42,
        tabHeight = 30,
        destroy = true
    } = props;

    const [activeKey, setActiveKey] = useState(propActiveKey);
    useEffect(() => {
        if (propActiveKey) {
            setActiveKey(propActiveKey);
        } else {
            const findItem = items?.find((item) => item.isShow !== false);
            if (findItem) {
                setActiveKey(findItem.key);
                onChange?.(findItem.key);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propActiveKey, items]);

    return (
        <Tabs
            type="card"
            className={clsx('table-tabs', className)}
            style={style}
            items={items}
            activeKey={activeKey}
            destroyInactiveTabPane={destroy}
            renderTabBar={() => (
                <>
                    <div
                        className="flex justify-between items-center overflow-auto hidden-scrollbar"
                        style={{ height: `${tabHeight}px` }}
                    >
                        <div className="flex items-center whitespace-nowrap">
                            {items?.map((item, index) => item.isShow !== false && (
                                <div
                                    key={item.key}
                                    className={clsx(
                                        'py-1 px-4 flex items-center',
                                        'text-sm border border-b-0 border-gray bg-white cursor-pointer',
                                        { 'rounded-tl-md': index === 0 },
                                        { 'rounded-tr-md': index === items.length - 1 },
                                        item.key === activeKey ?
                                            'font-bold text-table-tab-selected' :
                                            'text-gray-dark02 hover:text-table-tab-selected'
                                    )}
                                    onClick={() => {
                                        setActiveKey(item.key);
                                        onChange?.(item.key);
                                    }}
                                >
                                    {item.label}
                                    {!!item.closable && (
                                        <IconButton
                                            icon={<Icon name="close" />}
                                            size={20}
                                            className="translate-x-2"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onClose?.(item.key);
                                            }}
                                        />
                                    )}
                                </div>
                            ))}
                            {tabBar?.left}
                        </div>
                        {!!(tabBar?.right || tabBar) && (
                            <div className="flex items-center">
                                {tabBar?.right || tabBar}
                            </div>
                        )}
                    </div>
                    {!!tableBar && (
                        <div
                            className="border border-b-0 border-gray"
                            style={{ height: tableBarHeight }}
                        >
                            {tableBar}
                        </div>
                    )}
                </>
            )}
        />
    );
};

export default TableTabs;
